import zenObservable from 'zen-observable';
export var Observable = zenObservable;
//# sourceMappingURL=zenObservable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/~/zen-observable-ts/lib/zenObservable.js
// module id = 340
// module chunks = 0